// Utility to get Sirius mode at runtime.
// The environment variable controls the mode of the app.

import { environment } from '@environments/environment';

export function getIsSiriusEnabled(): boolean {
  return environment.use_sirius;
}
